var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.669 6.394 12.856 1.58a.624.624 0 0 0-.481-.206H5.5c-.756 0-1.375.619-1.375 1.375v16.5c0 .756.619 1.375 1.375 1.375h11c.756 0 1.375-.619 1.375-1.375V6.875a.624.624 0 0 0-.206-.481zm-5.294-3.369 3.85 3.85h-3.85v-3.85zM16.5 19.25h-11V2.75H11v4.125a1.38 1.38 0 0 0 1.375 1.375H16.5v11z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 15.125h-8.25V16.5h8.25v-1.375zM15.125 11h-8.25v1.375h8.25V11z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reportsIcon.9c5cd804993adadb52440ea0ac05d8a8.svg";
export { ForwardRef as ReactComponent };